export const PROPOSAL_RFP_MAX_LENGTH = 20000;
export const COMPANY_INFO_MAX_LENGTH = 10000;
export const CHAT_MESSAGE_MAX_LENGTH = 2000;
export const CHAT_HISTORY_MAX_MESSAGES = 8;
export const CHAT_STORED_MAX_MESSAGES = 50;

export function prepareProposalInput({ rfpText, companyInfo }) {
  const boundedRfpText = String(rfpText || "").slice(0, PROPOSAL_RFP_MAX_LENGTH);
  if (boundedRfpText.length < 100) {
    throw new Error("Please paste at least 100 characters of the RFP.");
  }

  if (JSON.stringify(companyInfo || {}).length > COMPANY_INFO_MAX_LENGTH) {
    throw new Error("Company information must be 10,000 characters or fewer.");
  }

  return { rfpText: boundedRfpText, companyInfo: companyInfo || {} };
}

function boundedChatMessage(message) {
  return {
    role: message?.role === "user" ? "user" : "assistant",
    text: String(message?.text || "").slice(0, CHAT_MESSAGE_MAX_LENGTH),
  };
}

export function appendChatMessage(messages, message) {
  return [...(Array.isArray(messages) ? messages : []), boundedChatMessage(message)]
    .slice(-CHAT_STORED_MAX_MESSAGES);
}

export function prepareAssistantTurn(message, messages) {
  const currentMessage = String(message || "");
  if (currentMessage.length > CHAT_MESSAGE_MAX_LENGTH) {
    throw new Error("Messages must be 2,000 characters or fewer.");
  }

  const history = (Array.isArray(messages) ? messages : [])
    .slice(-CHAT_HISTORY_MAX_MESSAGES)
    .map(boundedChatMessage)
    .map(item => ({ role: item.role, content: item.text }));

  return {
    userMessage: { role: "user", text: currentMessage },
    request: { message: currentMessage, history },
  };
}
